import LoaderBubbles from '@components/LoaderBubbles/LoaderBubbles'
import Logo from '@components/Logo/Logo'
import { Box, Stack } from '@mui/material'

export default function MainLoader() {
	return (
		<Box>
			<LoaderBubbles />
			<Stack height="100vh" p="1rem" spacing="1.5rem" justifyContent="center" alignItems="center">
				<Box sx={{ height: '3rem' }}>
					<Logo width="100%" />
				</Box>
			</Stack>
		</Box>
	)
}
